export const statsES = {
  title: 'Estadísticas & Evaluaciones'
}